import Subscription from "../../components/screen/profile/Subscription";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";

const SubscriptionPage = () => {
  return (
    <div className="">
      <PageTemplate
        header=""
        mainComponent={
          <div className="mt-24 lg:mt-0">
            <Subscription />
          </div>
        }
        pageRole={0}
      />
    </div>
  );
};

export default SubscriptionPage;
